<template>
    <div class="staff">
        <section class="home-cards">
        <h4>Staff Policies</h4>
        <hr class="hr">
        <p>Welcome to the school's resource center for all policies and guidelines for members of staff</p>
        <div class="home-cards-main">
            <div class="home-cards-cards">
              <router-link
                class="link"
                :to="{ name: 'Homework'}"
              >
                <div class="feature">
                    <div class="feature-img undraw">
                    <img src="@/assets/statsy.svg" alt="homework">
                    </div>
                    <div class="feature-title">
                    <h5>Homework Policy</h5>
                    </div>
                    <div class="feature-detail">
                    <p>Click to view the school policy on homework</p>
                    </div>
                </div>
              </router-link>
              <router-link
                class="link"
                :to="{ name: 'ChartDisplay'}"
              >
                <div class="feature">
                    <div class="feature-img undraw">
                    <img src="@/assets/charts.svg" alt="sport">
                    </div>
                    <div class="feature-title">
                    <h5>Charts/Class Displays</h5>
                    </div>
                    <div class="feature-detail">
                    <p>Click to view the school policy on charts and other class displays</p>
                    </div>
                </div>
              </router-link>
            </div>
        </div>
        </section>
    </div>
</template>

<script>

export default {
  name: 'Staff',
  components: { }
}
</script>

<style>
.staff .home-cards .hr {
  width: 80%;
  margin: 0 auto;
  margin-bottom: 2em;
}
.staff .home-cards h4 {
  padding-top: 2em;
  font-size: 2em;
  font-weight: 700;
  letter-spacing: 2px;
  padding-bottom: 4px;
  color: #fff;
}
.staff .home-cards .home-cards-main {
  display: grid;
  grid-gap: 0.8rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  padding: 1em;
}
.staff .home-cards .home-cards-cards {
  display: grid;
  grid-gap: 0.8rem;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
}
.staff .home-cards-cards .feature {
  margin: 5px;
  border-radius: 10px;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: .5s ease all;
}
.staff .home-cards-cards .feature:hover {
  box-shadow: 10px 10px 26px rgba(0, 0, 0, 0.5);
}
.staff .home-cards-cards .feature h5 {
  font-size: 1.8em;
  color: #fff;
  font-weight: 500;
  padding: 4px;
}
.staff .home-cards-cards .feature p {
  color: var(--inspire-charcoal);
}
.staff .feature .feature-img {
  width: 45px;
  margin: 5px auto;
}
.staff .feature .feature-img.undraw {
  width: 85px;
  margin: 5px auto;
}
.staff .home-cards-cards .feature .feature-detail {
  padding: 8px;
  font-size: 1.2em;
}
</style>
